import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "Yvooa-Core",
  storage: sessionStorage,
});

export const portfolioTreeStore = atom({
  key: "portfolioTreeStore",
  default: {
    portfolio: {},
    property: {},
    floorPlan: {},
    unit: {},
    tenant: {},
    maintenance: {},
    dashboardStat: "",
  },
  effects_UNSTABLE: [persistAtom],
});

export const batchChargesTreeStore = atom({
  key: "batchChargesTreeStore",
  default: {},
  effects_UNSTABLE: [persistAtom],
});
